import React from 'react';
import { type RouteObject } from 'react-router-dom';

import PageResetPassword from './index';

/**
 * Routes for the forgot-password / set-password flow (SPB-480).
 *
 * Like `/login` and `/register`, this is a full-bleed experience that owns the whole
 * viewport and brings its own backdrop, so it is mounted as a standalone route (NOT
 * through the account-chrome layouts in `router.tsx`) and is NOT auth-gated: it is a
 * screen an unauthenticated visitor must be able to reach (linked from `/login`'s
 * "Forgot password?"). `src/routes.tsx` prepends these before the config-driven routes so they
 * win the specificity tie against any remote config page at these paths.
 *
 * The SAME page is dual-mounted at two paths:
 * - `/reset-password` (hyphen): the request form, target of the in-app "Forgot password?" link
 *   and `ROUTE.resetPassword()`.
 * - `/reset_password` (underscore): the redemption landing, because the shipped
 *   micros-wl_owner_hub forgot-password email (notification 10010) links to
 *   `{ownerHubFrontUrl}/reset_password?code=<code>`. Without this mount the real emailed link
 *   would fall through to the config `*` catch-all and 404 silently. The page reads `?code=` and
 *   works identically on either path.
 */
export const resetPasswordRoute: RouteObject = {
  path: '/reset-password',
  element: <PageResetPassword />,
};

/** Underscore alias matching the BE forgot-password email link (`/reset_password?code=`). */
export const resetPasswordEmailRoute: RouteObject = {
  path: '/reset_password',
  element: <PageResetPassword />,
};

export default resetPasswordRoute;
